import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull/components/Layout';
import { getTestIds } from 'seagull/utils/TestIds';
import { RelationshipPdfTaskCard } from './cards/RelationshipPdfTaskCard';
import styles from './TasksDrawer.module.scss';
import { useActiveTasks } from './tasksStore';
import { useTaskResync } from './useTaskResync';
export const GetTasksDrawerTID = (parentTestId)=>getTestIds(parentTestId);
const TaskCardDispatcher = (param)=>{
    let { task, cardTestId } = param;
    switch(task.kind){
        case 'relationshipPdf':
            return /*#__PURE__*/ _jsx(RelationshipPdfTaskCard, {
                task: task,
                testId: cardTestId
            });
    }
};
export const TasksDrawer = (param)=>{
    let { testId } = param;
    useTaskResync();
    const tasks = useActiveTasks();
    const { TasksDrawerTestIds } = useMemo(()=>GetTasksDrawerTID(testId), [
        testId
    ]);
    if (tasks.length === 0) return null;
    return /*#__PURE__*/ _jsx(Box, {
        testId: TasksDrawerTestIds.Root(),
        className: styles.tasksDrawer,
        children: tasks.map((t)=>/*#__PURE__*/ _jsx(TaskCardDispatcher, {
                task: t,
                cardTestId: TasksDrawerTestIds.Card(t.jobId)
            }, t.jobId))
    });
};
